module.exports = __webpack_public_path__ + "static/media/all.0f78fb74.png";